import { useAlertStore } from './defines/store/alertStore';
import { Transition } from '@headlessui/react';
import { CheckCircleIcon, XMarkIcon, ExclamationCircleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';

export const AlertProvider = ({ children }: { children: React.ReactNode }) => {
    const [backgroundColor, setBackgroundColor] = useState('bg-rose-100');

    const alertStore = useAlertStore();

    useEffect(() => {
        alertStore.type === 'info' && setBackgroundColor('bg-blue-100');
        alertStore.type === 'error' && setBackgroundColor('bg-rose-100');
        alertStore.type === 'success' && setBackgroundColor('bg-green-100');
        alertStore.type === 'warning' && setBackgroundColor('bg-yellow-100');
        
        const timer = setTimeout(() => {
            alertStore.setShow(false);
        }, 3000);
        return () => clearTimeout(timer);
    }, [alertStore.show]);

    return (
        <div>
            <Transition show={alertStore.show}>
                <div className={`pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg 
            bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition 
            data-[closed]:data-[enter]:translate-y-2 data-[enter]:transform 
            data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-100 
            data-[enter]:ease-out data-[leave]:ease-in data-[closed]:data-[enter]:sm:translate-x-2 
            data-[closed]:data-[enter]:sm:translate-y-0 fixed bottom-12 right-4 z-50 backdrop-blur-lg bg-opacity-75 ` + backgroundColor}
            style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 10px 15px rgba(0, 0, 0, 0.1)' }}>
                    <div className="p-4">
                        <div className="flex items-start">
                            <div className="flex-shrink-0">
                                {alertStore.type === 'info' && <InformationCircleIcon aria-hidden="true" className="h-10 w-10 text-blue-500" />}
                                {alertStore.type === 'error' && <ExclamationCircleIcon aria-hidden="true" className="h-10 w-10 text-red-500" />}
                                {alertStore.type === 'success' && <CheckCircleIcon aria-hidden="true" className="h-10 w-10 text-green-500" />}
                                {alertStore.type === 'warning' && <ExclamationCircleIcon aria-hidden="true" className="h-10 w-10 text-yellow-500" />}
                            </div>
                            <div className="ml-3 w-0 flex-1 pt-0.5">
                                <p className="text-base font-medium">{alertStore.title}</p>
                                <p className="mt-1 text-base">{alertStore.message}</p>
                            </div>
                            <div className="ml-4 flex flex-shrink-0">
                                <button
                                    type="button"
                                    onClick={() => {
                                        alertStore.setShow(false);
                                    }}
                                    className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                >
                                    <span className="sr-only">Close</span>
                                    <XMarkIcon aria-hidden="true" className="h-5 w-5" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Transition>
            {children}
        </div>
    );
};